export default __webpack_public_path__ + "static/media/logo-alpura.650cdaa5.png";